module.exports = __webpack_public_path__ + "img/background-auth.5de747f6.png";